export default __webpack_public_path__ + "static/media/arrow_forward_blue_24dp.c549da6c.png";